import SetPasswordPage from "./components/set-password/SetPasswordPage";
import "./styles/Auth.module.css";

const SetPassword = () => {
  return (
    <div className="auth-container">
      <div className="auth-form">
        <SetPasswordPage />
      </div>
    </div>
  );
};

export default SetPassword;
